export const CALENDAR_START_HOUR = 5
export const CALENDAR_END_HOUR = 24

export const TZ = process.env.NEXT_PUBLIC_TIMEZONE || process.env.NEXT_PUBLIC_TZ
